import React from 'react';
import { Link } from 'react-router-dom';

export default function TermsOfService() {
  const updated = new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="legal-back" data-testid="terms-back-home">← Back to Home</Link>
        <h1>Terms &amp; Conditions</h1>
        <p className="legal-updated">Last updated: {updated}</p>

        <p>
          These terms govern your use of services provided by PBNJ Backflow Testing, including our
          online booking and SMS text messaging program.
        </p>

        <h2>SMS Text Messaging Program</h2>
        <p>
          <strong>Program name:</strong> PBNJ Backflow Testing Appointment Notifications.
        </p>
        <p>
          By providing your phone number and submitting our booking form, you agree to receive SMS text
          messages from PBNJ Backflow Testing related to your service. These messages may include:
        </p>
        <ul>
          <li>Appointment confirmations and scheduling</li>
          <li>Appointment reminders</li>
          <li>Arrival-window and post-visit information</li>
          <li>Billing notifications</li>
        </ul>
        <p>
          <strong>Message frequency varies.</strong> <strong>Message and data rates may apply.</strong>
        </p>
        <p>
          For help, reply <strong>HELP</strong> to any message or contact us at (469) 505-4321. To stop
          receiving messages, reply <strong>STOP</strong> at any time and you will be unsubscribed.
        </p>
        <p>
          Carriers are not liable for delayed or undelivered messages. Your mobile opt-in information is
          handled per our{' '}
          <Link to="/privacy">Privacy Policy</Link> and is never shared with third parties for marketing.
        </p>

        <h2>Services</h2>
        <p>
          We provide certified backflow testing for residential irrigation and commercial backflow
          assemblies. We do not service fire-system backflow devices. Appointment times include an
          arrival window, and you do not need to be present if the device is accessible outside your fence.
        </p>

        <h2>Contact</h2>
        <p>
          Call or text <strong>(469) 505-4321</strong> or email{' '}
          <a href="mailto:info@pbnjbackflowtesting.com">info@pbnjbackflowtesting.com</a>.
        </p>
      </div>
    </div>
  );
}
